// extracted by mini-css-extract-plugin
module.exports = {"header":"payment-settings_header_3tkyD","button":"payment-settings_button_zjKam"};